import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./css/App.css";
import { Layout } from "./layouts";
import { LandingPage } from "./pages";

function App() {
  const router = createBrowserRouter([
    {
      element: <Layout />,
      children: [
        {
          path: "/",
          element: <LandingPage />,
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;
